import { useClientSide } from '@carvana/merch-react-hooks';
import cx from 'classnames';
import { useContext, useState } from 'react';
import PassengerTools from '@/common/PassengerTools';
import didSetNativeAppCapabilities from '~/constants/common/didSetNativeAppCapabilities';
import { isTest } from '~/constants/environment';
import StaticContext from '~/context/common/StaticContext';
import { getAppCapabilitiesCookieName } from '~/native/utils';
import BrowserCookies from '~/utilities/BrowserCookies';
import { withErrorBoundary } from '~/utilities/ErrorBoundary';
import { getEnabledCookieName } from '~/utilities/featureBranch';
import FeatureBranchBanner from './FeatureBranchBanner';
import PassengerToolsButton from './PassengerToolsButton';

type OwnProps = {
  className?: string;
};

function CommonFeatureBranch({ className }: OwnProps) {
  const { clientId, kubernetesAppName } = useContext(StaticContext);
  const [showPassenger, setShowPassenger] = useState(false);

  const isClientSide = useClientSide();

  const isFeatureBranchEnabled =
    BrowserCookies.get(getEnabledCookieName(kubernetesAppName)) === 'true';

  const currentNativeAppCapabilities = BrowserCookies.get(
    getAppCapabilitiesCookieName(clientId)
  )?.replace(/,/g, ', ');
  const isNativeAppCapabilitiesEnabled =
    Boolean(currentNativeAppCapabilities) &&
    BrowserCookies.get(didSetNativeAppCapabilities[clientId] ?? '');

  const isEnabled = isFeatureBranchEnabled || isNativeAppCapabilitiesEnabled;

  const handleOpenPassengerTools = () => {
    setShowPassenger(true);
  };

  return isClientSide && isTest ? (
    <>
      <div
        className={cx(
          'pointer-events-none absolute inset-0 z-[99999] mx-auto u:max-w-[1800px]',
          className
        )}
      >
        {isEnabled ? (
          <FeatureBranchBanner
            currentNativeAppCapabilities={currentNativeAppCapabilities}
            onOpenPassengerTools={handleOpenPassengerTools}
          />
        ) : (
          <PassengerToolsButton
            onOpenPassengerTools={handleOpenPassengerTools}
          />
        )}
      </div>
      {showPassenger && <PassengerTools setShowModal={setShowPassenger} />}
    </>
  ) : null;
}

export default withErrorBoundary(CommonFeatureBranch);
